export default "__VITE_ASSET__M9CYpbe7__"